import {LayoutEnum} from './layout.enum';

export class FlexLayoutItem {

    static layoutNames = [];

    layout: LayoutEnum;
    layoutAlign?: string;
    flex?: string;
    class?: string;
    name?: string;
    maxCollapsedWidth?: number;
    items?: FlexLayoutItem[];

    parentLayout: FlexLayoutItem;
    col?: number;
    row?: number;
    colspan = 0;
    rowspan = 0;

    private layoutName: string;

    constructor(flexLayoutItem?: Partial<FlexLayoutItem>) {
        this.layoutName = FlexLayoutItem.getRandomFlexLayoutItemName();

        if (!flexLayoutItem) {
            return;
        }

        Object.assign(this, flexLayoutItem);
    }

    static getRandomFlexLayoutItemName(): string {
        do {
            const layoutName = Math.random().toString(36).slice(-5);

            if (!this.layoutNames.includes(layoutName)) {
                this.layoutNames.push(layoutName);

                return layoutName;
            }
        } while (true);
    }

    public getLayoutName(): string {
        return this.layoutName;
    }
}
